import { Stack } from '@mui/material';
import { Divider, Subheadline } from '@telegram-apps/telegram-ui';
import { CircularProgressWithIcon } from '../../common/CircularProgressWithIcon';

export const GoalDisplayPlaceholder = () => (
    <Stack direction="row" alignItems="center" gap={0.5} sx={{ opacity: 0.3 }}>
        <CircularProgressWithIcon icon="add" progress={0} />
        <Stack>
            <Subheadline weight="3" style={{ fontSize: '10px', lineHeight: '10px' }} />
            <Divider style={{ margin: '4px 0px' }} />
            <Subheadline weight="3" style={{ fontSize: '10px', lineHeight: '10px' }} />
        </Stack>
    </Stack>
); 